import {isArray} from 'lodash';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {CSVLink} from 'react-csv';
import DatePicker from 'react-datepicker';
import {useTranslation} from 'react-i18next';
import ReactPaginate from 'react-paginate';
import {connect, useSelector} from 'react-redux';
import BeatLoader from 'react-spinners/BeatLoader';
import {RootState} from 'store/reducers';
import {userType} from 'views/types/user.types';
import {getRegistrarLeads} from '../../store/actions/lead.action';
import {getRegistrarPayload} from '../../types/lead.actions.types';
import {generateIntegrationLink, getMyRole, roles} from '../../utils/handler';
import AffiliateIdCard from 'views/registrar-integrations/AffiliateIdCard';

interface baseLead {
  date: string;
  clicks: string;
  sales: string;
  commission: number;
  sales_commission: number;
  refunds: undefined;
  total: '';
  total_initialFee: number;
  total_click: number;
  total_soldCount: number;
  total_saleCommission: number;
  total_refunds: number;
  total_amount: number;
}
interface consolidateData {
  name: string;
  clicks: string;
  sales: string;
  commission: number;
  sales_commission: number;
  refunds: undefined;
  total: '';
}
interface tableHeader {
  label: string;
  key: string;
}
const headers: tableHeader[] = [
  { label: 'Date', key: 'date' },
  { label: 'Clicks', key: 'clicks' },
  { label: 'Sales', key: 'sales' },
  { label: 'Initial Fee', key: 'commission' },
  { label: 'Sales Commision', key: 'sales_commission' },
  { label: 'Refund', key: 'refunds' },
  { label: 'Total', key: 'total' },
];
interface sortOption {
  name: string;
  type: string;
  sortType: string;
}
const sortOptions: sortOption[] = [
  { name: 'Date', sortType: 'DESC', type: '(newest first)' },
  { name: 'Date', sortType: 'ASC', type: '(oldest first)' },
  { name: 'Total', sortType: 'ASC', type: '(min first)' },
  { name: 'Total', sortType: 'DESC', type: '(max first)' },
  { name: 'Clicks', sortType: 'ASC', type: '(min first)' },
  { name: 'Clicks', sortType: 'DESC', type: '(max first)' },
];

const RegistrarDashboard: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const [accordionList, setAccordionList] = useState<Number[]>([0]);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [limit, setLimit] = useState<number>(10);
  const [totalRows, setTotalRow] = useState<number>(10);
  const [leadList, setLeadList] = useState<baseLead[]>();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [sortBy, setSortBy] = useState('Date');
  const [sortType, setSortType] = useState('DESC');
  const [registrarUID, setRegistrarUID] = useState('');
  // const [consolidateDashboard, setConsolidateDashboard] = useState(false);
  const consolidateDashboard= false
  const [dateFilter, setFilter] = useState<{ fromDate: string; toDate: string }>();
  const [fetchingData, setFetchingData] = useState(false);
  const [sortByString, setSortByString] = useState<string>('Sort');
  const [hasFilter, setHasFilter] = useState<boolean>(false);
  let { registrarList, myProfile } = useSelector((state: RootState) => state.userReducer);
  const adminPanel = getMyRole().includes(roles.admin);
  const [accountTotal, setAccountTotal] = useState<baseLead>();
  const [consolidatedData, setConsolidatedData] = useState<consolidateData[]>();

  const handleAccordion = (accordionIndex: number) => {
    let position: number = accordionList.indexOf(accordionIndex);
    if (position === -1) {
      accordionList.push(accordionIndex);
    } else {
      accordionList.splice(position, 1);
    }
    setAccordionList([...accordionList]);
  };

  const getLeads = async (payload: getRegistrarPayload = { consolidateDashboard, registrarUID, limit, pageNumber, sortType, sortBy, dateFilter }) => {
    payload.limit = payload.limit || limit;
    payload.pageNumber = payload.pageNumber || pageNumber;
    payload.sortType = payload.sortType || sortType;
    payload.sortBy = payload.sortBy || sortBy;
    payload.registrarUID = registrarUID;
    if (dateFilter || payload.dateFilter) {
      payload.dateFilter = payload.dateFilter || dateFilter;
    }
    if (leadList?.length === 0) {
      setFetchingData(true);
    }
    await getRegistrarLeads(payload)
      .then((res) => {
        let leads: any = [];
        if (res && res.leads) {
          if (payload.consolidateDashboard) {
            let consolidatedData: consolidateData[] = [];
            for (const lead of res.leads) {
              let obj: any = {
                name: lead.name,
                clicks: lead.clicks || 0,
                sales: lead.sales || 0,
                commission: getFloatValueToFixed(lead.commission),
                sales_commission: getFloatValueToFixed(lead.sales_commission),
                refunds: getFloatValueToFixed(lead.refunds),
                total: getFloatValueToFixed(lead.total),
              };
              consolidatedData.push(obj);
            }
            setConsolidatedData(consolidatedData);
          } else {
            let count = 0;
            for (const lead of res.leads) {
              let obj: any = {
                date: moment(lead.date).format('MM/DD/YYYY'),
                clicks: lead.clicks || 0,
                sales: lead.sales || 0,
                commission: getFloatValueToFixed(lead.commission),
                sales_commission: getFloatValueToFixed(lead.sales_commission),
                refunds: getFloatValueToFixed(lead.refunds),
                total: getFloatValueToFixed(lead.total),
              };
              if (count === 0 && lead) {
                setAccountTotal(lead);
              }
              count = count + 1;
              leads.push(obj);
            }
          }
        }
        if (res && res.totalRows) {
          setTotalRow(res.totalRows);
        } else {
          setTotalRow(0);
        }

        if (leads.length === 0) {
          setTotalRow(0);
        }

        setFetchingData(false);
        setLeadList(leads);
      })
      .catch((e) => {
        setFetchingData(false);
      });
  };
  // const getPaymentConcile = async () => {
  //   const data = { source: registrarUID, status: 'all' };
  //   await getPaymentReconcileCSV(data);
  // };
  const getFloatValueToFixed = (value: number, toFIx: number = 2) => {
    return parseFloat((value || 0).toString()).toFixed(toFIx) || '0.00';
  };
  useEffect(() => {
    getLeads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrarUID]);

  const handlePageChange = (pageNo: number) => {
    getLeads({ pageNumber: pageNo });
    setPageNumber(pageNo);
  };

  const handleSort = (sortObject: sortOption) => {
    let sortedBy = sortObject.name;
    let sortOrder = sortObject.sortType;
    let sortedByString = sortedBy + ' ' + sortObject.type;
    setSortBy(sortedBy);
    setSortType(sortOrder);
    setSortByString(sortedByString);
    setHasFilter(true);
    getLeads({ sortBy: sortedBy, sortType: sortOrder });
  };
  const changeLimit = (changedLimit: string) => {
    setLimit(parseInt(changedLimit));
    setPageNumber(1);
    getLeads({ limit: parseInt(changedLimit), pageNumber: 1 });
  };
  const clearFilter = () => {
    let filterDate = { fromDate: '', toDate: '' };
    setFilter(filterDate);
    let sortedBy = 'Date';
    let sortedType = 'DESC';
    setSortType(sortType);
    setSortBy(sortedBy);
    setHasFilter(false);
    setStartDate(null);
    setEndDate(null);
    setSortByString('Sort');
    getLeads({ dateFilter: filterDate, pageNumber: 1, sortBy: sortedBy, sortType: sortedType });
  };

  const onFilterChange = (dates: any) => {
    let fromDate: string = dates[0];
    let toDate: string = dates[1];
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if ((fromDate && toDate) || (!fromDate && !toDate)) {
      let filterDate = { fromDate, toDate };
      setFilter(filterDate);
      setPageNumber(1);
      setHasFilter(true);
      getLeads({ dateFilter: filterDate, pageNumber: 1 });
    }
  };
  // console.log('consolidatedData', consolidatedData, consolidateDashboard)
  return (
    <div className="container mt-3 mb-5">
      <div className="row">
        <div className="col-12">
          {!adminPanel && (
            <div className="row justify-content-between">
              <div className="col-auto">
                <label className="title mb-1">
                  <span>{t('Dashboard')}</span>{' '}
                </label>
              </div>
              <div className="col-auto">
                <span className="copy-integration-link text-primary mt-2 c-pointer mr-3 " onClick={(e) => generateIntegrationLink()}>
                  <i className="fas fa-link  mr-2"></i>Get Integration Link
                </span>
                {isArray(leadList) && (
                  <CSVLink data={leadList || []} headers={headers} filename={'saw-report.csv'}>
                    <label className="theme-color mt-2 c-pointer">
                      <i className="fas fa-download mr-2 "></i>
                      {t('Export')}{' '}
                    </label>
                  </CSVLink>
                )}
              </div>
            </div>
          )}

          {!adminPanel && myProfile?.UID && (
            <div className="registrar-affiliate-id">
              <AffiliateIdCard affiliateId={myProfile.UID} />
            </div>
          )}

          <div className="solid-border p-2" id="divToPrint">
            <div className="table-responsive">
              <div className="d-flex justify-content-between align-items-center px-1">
                <div className="sub-title">
                  {t('Affiliate Revenue')}
                  {/* {adminPanel && (
                    <span className='ml-2'>
                      <i title={adminPanel ? "Show Consolidated Dashboard" : "Hide Consolidated Dashboard"} className={"fa-solid fa-lg theme-color " + (consolidateDashboard ? "fa-toggle-on" : "fa-toggle-off")} onClick={() => {setConsolidateDashboard(!consolidateDashboard); getLeads({consolidateDashboard: !consolidateDashboard})}}></i>
                    </span>)} */}
                </div>
                {adminPanel && (
                  <>
                    <select title="Registrar filters" className="form-control w-50" value={registrarUID} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setRegistrarUID(e.target.value)}>
                      <option selected value={''} disabled>
                        Choose Registrar
                      </option>
                      <option value={'all'}>All Transactions</option>
                      <option value={'general'}>Direct Users</option>
                      {registrarList.map((user: userType, index: number) => (
                        <option key={index} value={user.UID}>
                          {user.name}
                        </option>
                      ))}
                    </select>
                    {/* <input onChange={() => {setConsolidateDashboard(!consolidateDashboard); getLeads({consolidateDashboard: !consolidateDashboard})}} id="toggle-demo" type="checkbox" data-toggle="toggle" /> */}
                    {/* <toggle>consolidateDashboard</toggle> */}
                  </>
                )}
              </div>
              <div className="filter-container">
                <div className="page-filter ml-1">
                  <select title="Limit count" className="form-control" value={limit} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => changeLimit(e.target.value)}>
                    <option disabled={true} defaultValue={''}>
                      {t('Select Limit')}
                    </option>
                    <option value={10}>10 Records</option>
                    <option value={30}>30 Records</option>
                    <option value={60}>60 Records</option>
                    <option value={90}>90 Records</option>
                    <option value={Math.max(totalRows, 1)}>All Records</option>
                  </select>
                  <div className="form-control clear-all-button" onClick={() => clearFilter()}>
                    <span>Clear Filter </span>
                    <i className="far fa-times-circle text-danger c-pointer" data-toggle="tooltip" title={t('Clear All Filter')}></i>
                  </div>
                </div>
                <div className="filter-options">
                  {/* {leadList && leadList.length > 0 && (
                    <button className=" btn fs-18 btn-grad" onClick={() => getPaymentConcile()}>
                      Download
                    </button>
                  )} */}
                  <div className="dropdown  filter-sort ">
                    <label className="form-control c-pointer p-2" id="dropdownMenuButton-registrar" data-toggle="dropdown" aria-haspopup="true">
                      <div className="">
                        <i className="fas fa-sort "></i> {t(sortByString)}
                      </div>
                    </label>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton-registrar">
                      {sortOptions.map((sortOption: sortOption, index: number) => (
                        <span className="dropdown-item " key={index} onClick={() => handleSort(sortOption)}>
                          {t(sortOption.name)} {t(sortOption.type)}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className=" filter-date mr-1">
                    <DatePicker maxDate={new Date()} selected={startDate} onChange={onFilterChange} startDate={startDate} endDate={endDate} selectsRange className="form-control date-picker-102" placeholderText={'Filter Date'}></DatePicker>
                  </div>
                  {hasFilter && (
                    <div className="clear-filter">
                      <i onClick={() => clearFilter()} className="far fa-times-circle text-danger c-pointer clear-all-icon" data-toggle="tooltip" title={t('Clear All Filter')}></i>
                    </div>
                  )}
                </div>
              </div>

              {consolidateDashboard ? (
                <table className="registrar-table table text-center  table-striped table-hover">
                  <thead>
                    <tr className="">
                      <th scope="col" id="date">
                        {t('Name')} <div className="fs-10 text-primary">{t('(Registrar Name)')}</div>
                      </th>
                      <th scope="col">
                        {t('Clicks')} <div className="fs-10 text-primary">{t('(Count)')}</div>
                      </th>
                      <th scope="col">
                        {t('Sales')}
                        <div className="fs-10 text-primary">{t('(Count)')}</div>
                      </th>
                      <th scope="col">
                        {t('Initial Fee')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('Your portion of Initial fee collected from accepted Referred Users.')}></i>
                        <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                      </th>
                      <th scope="col">
                        {t('Sales Commission')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('Sales commission actually received by Broker for the sale of a queried domain name.')}></i>
                        <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                      </th>
                      <th scope="col">
                        {t('Refunds')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('The amount refunded or charged back to Referred Users')}></i>
                        <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                      </th>
                      <th scope="col">
                        {t('Total')} <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchingData ? (
                      <tr>
                        <td colSpan={10} className="text-center table-loader">
                          <BeatLoader color="#ff7728" />
                        </td>
                      </tr>
                    ) : !consolidatedData || consolidatedData.length === 0 ? (
                      <tr>
                        <td colSpan={10} className="text-center">
                          {t('No Record found')}
                        </td>
                      </tr>
                    ) : isArray(consolidatedData) ? (
                      <>
                        {consolidatedData?.map((lead, index) => (
                          <tr key={index}>
                            <th scope="row">{lead.name}</th>
                            <td>{lead.clicks || 0}</td>
                            <td>{lead.sales || 0}</td>
                            <td>{parseFloat((lead.commission || 0).toString()).toFixed(2)}</td>
                            <td>{lead.sales_commission}</td>
                            <td>{lead.refunds}</td>
                            <td>{lead.total}</td>
                          </tr>
                        ))}
                      </>
                    ) : null}
                  </tbody>
                </table>
              ) : (
                <>
                  <table className="registrar-accordion table   table-striped table-hover">
                    <tbody>
                      {fetchingData && (
                        <tr>
                          <td colSpan={10} className="text-center table-loader">
                            <BeatLoader color="#ff7728" />
                          </td>
                        </tr>
                      )}
                      {!leadList || leadList.length === 0 ? (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t('No Record found')}
                          </td>
                        </tr>
                      ) : (
                        isArray(leadList) &&
                        leadList.map((lead: any, index) => (
                          <tr className="accordion" key={index}>
                            <td className="d-flex mt-2">
                              <div className="col-10">
                                <label>
                                  {' '}
                                  {t('Date')} <div className="fs-10 text-primary">{t('(MM/DD/YYYY)')}</div>
                                </label>
                                <span className="float-right">{lead.date}</span>
                              </div>
                              <div className="col-2 text-center">
                                <i className={'fas  fa-lg theme-color ' + (accordionList.indexOf(index) === -1 ? 'fa-plus' : 'fa-minus')} onClick={() => handleAccordion(index)}></i>
                              </div>
                            </td>
                            <td className={accordionList.indexOf(index) === -1 ? 'd-none' : 'd-block'} id={'accordion_' + index}>
                              <div className="col-10 ">
                                <label>
                                  {t('Clicks')} <div className="fs-10 text-primary">{t('(Count)')}</div>
                                </label>
                                <span className="float-right">{lead.clicks}</span>
                              </div>
                              <div className="col-10 ">
                                <label>
                                  {t('Sales')} <div className="fs-10 text-primary">{t('(Count)')}</div>
                                </label>
                                <span className="float-right">{lead.sales || 0}</span>
                              </div>
                              <div className="col-10 ">
                                <label>
                                  {t('Initial Fee')} <i className="theme-color fas fa-question-circle" onClick={() => alert('Your portion of Initial fee collected from accepted Referred Users.')}></i>
                                  <div className="fs-10 text-primary">{t('(Dollars $)')}</div>{' '}
                                </label>
                                <span className="float-right">{lead.commission}</span>
                              </div>
                              <div className="col-10 ">
                                <label>
                                  {t('Sales Commission')} <i className="theme-color fas fa-question-circle" onClick={() => alert('Sales commission actually received by Broker for the sale of a queried domain name.')}></i>
                                  <div className="fs-10 text-primary">{t('(Dollars $)')}</div>{' '}
                                </label>
                                <span className="float-right">{lead.sales_commission}</span>
                              </div>
                              <div className="col-10 ">
                                <label>
                                  {t('Refunds')} <i className="theme-color fas fa-question-circle" onClick={() => alert('The amount refunded or charged back to Referred Users')}></i>
                                  <div className="fs-10 text-primary">{t('(Dollars $)')}</div>{' '}
                                </label>
                                <span className="float-right">{lead.refunds}</span>
                              </div>
                              <div className="col-10 ">
                                <label>
                                  {t('Total')} <div className="fs-10 text-primary">{t('(Dollars $)')}</div>{' '}
                                </label>
                                <span className="float-right">{lead.total}</span>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <table className="registrar-table table text-center  table-striped table-hover">
                    <thead>
                      <tr className="">
                        <th scope="col" id="date">
                          {t('Date')} <div className="fs-10 text-primary">{t('(MM/DD/YYYY)')}</div>
                        </th>
                        <th scope="col">
                          {t('Clicks')} <div className="fs-10 text-primary">{t('(Count)')}</div>
                        </th>
                        <th scope="col">
                          {t('Sales')}
                          <div className="fs-10 text-primary">{t('(Count)')}</div>
                        </th>
                        <th scope="col">
                          {t('Initial Fee')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('Your portion of Initial fee collected from accepted Referred Users.')}></i>
                          <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                        </th>
                        <th scope="col">
                          {t('Sales Commission')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('Sales commission actually received by Broker for the sale of a queried domain name.')}></i>
                          <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                        </th>
                        <th scope="col">
                          {t('Refunds')} <i className="theme-color fas fa-question-circle" data-toggle="tooltip" title={t('The amount refunded or charged back to Referred Users')}></i>
                          <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                        </th>
                        <th scope="col">
                          {t('Total')} <div className="fs-10 text-primary">{t('(Dollars $)')}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetchingData ? (
                        <tr>
                          <td colSpan={10} className="text-center table-loader">
                            <BeatLoader color="#ff7728" />
                          </td>
                        </tr>
                      ) : !leadList || leadList.length === 0 ? (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t('No Record found')}
                          </td>
                        </tr>
                      ) : isArray(leadList) ? (
                        <>
                          {leadList.map((lead, index) => (
                            <tr key={index}>
                              <th scope="row">{lead.date}</th>
                              <td>{lead.clicks || 0}</td>
                              <td>{lead.sales || 0}</td>
                              <td>{parseFloat((lead.commission || 0).toString()).toFixed(2)}</td>
                              <td>{lead.sales_commission}</td>
                              <td>{lead.refunds}</td>
                              <td>{lead.total}</td>
                            </tr>
                          ))}
                          {accountTotal && (
                            <tr className="f-bold theme-background">
                              <th scope="row">Total</th>
                              <td>{accountTotal.total_click || 0}</td>
                              <td>{accountTotal.total_soldCount || 0}</td>
                              <td>{getFloatValueToFixed(accountTotal.total_initialFee)}</td>
                              <td>{getFloatValueToFixed(accountTotal.total_saleCommission)}</td>
                              <td>{getFloatValueToFixed(accountTotal.total_refunds)}</td>
                              <td>{getFloatValueToFixed(accountTotal.total_amount)}</td>
                            </tr>
                          )}
                        </>
                      ) : null}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
        {totalRows > limit && (
          <div className="col-12 d-flex justify-content-end mt-2">
            <ReactPaginate previousLabel={'<'} nextLabel={'>'} breakLabel={'...'} pageCount={Math.ceil(totalRows / limit)} marginPagesDisplayed={3} pageRangeDisplayed={3} onPageChange={(e) => handlePageChange(e.selected + 1)} containerClassName={'pagination'} activeClassName={'active'} forcePage={parseInt(pageNumber) - 1} />
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(RegistrarDashboard);
